import { api, ApiError, getAuthCredentials } from './client'
import type { OrgBranding } from '@/types'

const BASE_URL: string = import.meta.env.VITE_API_URL ?? ''

function getToken(): string {
  try {
    return JSON.parse(localStorage.getItem('multiaccess-app') ?? '{}')?.state?.token ?? ''
  } catch {
    return ''
  }
}

async function uploadFile(endpoint: string, file: File): Promise<string> {
  const form = new FormData()
  form.append('file', file)
  const { orgId } = getAuthCredentials()
  const headers: Record<string, string> = { Authorization: `Bearer ${getToken()}` }
  if (orgId) {
    headers.organizationId = orgId
    headers.organisationID = orgId
    headers['X-Org-Id'] = orgId
  }
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'POST',
    body: form,
    headers,
  })
  if (!res.ok) throw new ApiError(res.status, 'UPLOAD_FAILED', 'Upload failed')
  const data = await res.json()
  return data.url as string
}

export const brandingApi = {
  get: () =>
    api.get<OrgBranding>('/api/v1/admin/branding'),

  save: (b: Partial<OrgBranding>) =>
    api.put<OrgBranding>('/api/v1/admin/branding', b),

  uploadLogo:      (file: File) => uploadFile('/api/v1/admin/branding/logo',       file),
  uploadLoginLogo: (file: File) => uploadFile('/api/v1/admin/branding/login-logo', file),
  uploadFavicon:   (file: File) => uploadFile('/api/v1/admin/branding/favicon',    file),

  verifyDomain: (domain: string) =>
    api.post<{ verified: boolean; txtRecord?: string }>('/api/v1/admin/branding/verify-domain', { domain }),

  previewCss: (css: string) =>
    api.post<{ valid: boolean; error?: string }>('/api/v1/admin/branding/preview-css', { css }),

  reset: () =>
    api.post<OrgBranding>('/api/v1/admin/branding/reset', {}),
}
